import type { PlaybookCondition } from "@repo/app-types/entities/filterConditions";
import type { PlaybookId } from "@repo/app-types/entities/playbook";
import { SimpleMenuItem } from "@repo/ui/Menu/simpleMenuItem";
import {
  longMenuMaxHeight,
  SimpleMenuPopover,
} from "@repo/ui/Menu/simpleMenuPopover";
import type { FC } from "react";
import { SubmenuTrigger } from "react-aria-components";
import { checkIsPlaybookHasResultCondition } from "./playbookCondition.js";
import { PlaybookConditionsMenu } from "./playbookConditionsMenu.js";
import { buildHasResultPlaybookCondition } from "./usePlaybookFilterDefaults.js";

export interface PlaybookConditionsFilterOptionProps {
  params: { playbookId?: PlaybookId };
  value: readonly PlaybookCondition[];
  onChange: (newValue: readonly PlaybookCondition[]) => void;
}

export const PlaybookConditionsFilterOption: FC<
  PlaybookConditionsFilterOptionProps
> = ({ params, value, onChange }) => {
  const playbookId = params.playbookId;

  if (playbookId === undefined) return null;

  const hasResultCondition = value.some(
    (condition) =>
      condition.playbookId === playbookId &&
      checkIsPlaybookHasResultCondition(condition),
  );

  return (
    <SubmenuTrigger>
      <SimpleMenuItem>Playbook results</SimpleMenuItem>

      <SimpleMenuPopover maxHeight={longMenuMaxHeight}>
        <PlaybookConditionsMenu
          playbookId={playbookId}
          includeCallsWithoutGrades={!hasResultCondition}
          onIncludeCallsWithoutGradesChange={(include) => {
            const valueWithoutHasResult = value.filter(
              (condition) =>
                condition.playbookId !== playbookId ||
                !checkIsPlaybookHasResultCondition(condition),
            );
            onChange(
              include
                ? valueWithoutHasResult
                : [
                    ...valueWithoutHasResult,
                    buildHasResultPlaybookCondition(playbookId),
                  ],
            );
          }}
          onSelect={(condition) => onChange([...value, condition])}
        />
      </SimpleMenuPopover>
    </SubmenuTrigger>
  );
};
